import { render } from "./AppSponsor.vue?vue&type=template&id=11bcb81d&scoped=true"
import script from "./AppSponsor.vue?vue&type=script&lang=js"
export * from "./AppSponsor.vue?vue&type=script&lang=js"

import "./AppSponsor.vue?vue&type=style&index=0&id=11bcb81d&lang=css"
import "./AppSponsor.vue?vue&type=style&index=1&id=11bcb81d&scoped=true&lang=css"

import exportComponent from "/var/www/html/levante_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11bcb81d"]])

export default __exports__